
import { createSlice, createAsyncThunk, nanoid } from "@reduxjs/toolkit";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import { resetAddLoadState, setKayitliAdresRouteItem, setKayitliYuklerAracData, setKayitliYuklerPaketlemeData, setKayitliYuklerPaymentData, setKayitliYuklerYukData, setKayitliYukRouteItem } from "../addLoad/addLoadSlice";
import { setKayitliAdresRouteItem as setKayitliAdresRouteItemUpdate } from "../updateLoad/updateLoadSlice";
import axiosInstance from "../../axios/axiosInstance";
import yuklemeTuruOptions from "../../utils/yukOptions/yüklemeTuruOptions";
import agirlikBirimOptions from "../../utils/yukOptions/agirlikBirimOptions";
import paketlemeItemDimensions from "../../utils/yukOptions/paketlemeItemDimension";
import zeminTypeOptions from "../../utils/yukOptions/zeminTypeOptions";
import sevkBicimleriOptions from "../../utils/yukOptions/sevkBicimleriOptions";
import addLoadLocationData from "../../utils/locationData/addLoadLocationOptions";
import fiyatlandirmaTipOptions from "../../utils/yukOptions/fiyatlandirmaTipOptions";
import { odemeSekliOptions } from "../../utils/yenıYukEkleOptions";
import yakitDurumuOptions from "../../utils/yukOptions/yakitDurumuOptions";
import komisyonDurumuOptions from "../../utils/yukOptions/komisyonDurumuOptions";
import { toast } from "react-toastify";
import { unwrapApiList } from "../../helper/load/registeredLoadPayload";

const getApiErrorMessage = (error) =>
    error?.response?.data?.error?.errors?.$values?.[0] ??
    error?.response?.data?.error?.errors?.[0] ??
    error?.response?.data?.error?.errorDetails ??
    error?.response?.data?.message ??
    error?.message ??
    "Bir hata oluştu, lütfen daha sonra tekrar deneyin.";

const showApiError = (error) => {
    if (error?.response?.status !== 403) toast.error(getApiErrorMessage(error));
};

const getResponseData = (response) =>
    response?.data && !Array.isArray(response.data) ? response.data : response;

const isSuccessfulResponse = (response) =>
    response?.statusCode == null || response.statusCode === 200;

const initialState = {

    isLoadingGetYukKaydiIsimleri: false,
    isLoadingGetAdresKaydiIsimleri: false,
    isLoadingGetKayitliAdresler: false,
    isLoadingGetKayitliYukler: false,
    isLoadingGetKayitliYukDetails: false,

    isLoadingAddKayitliLoad:false,
    isLoadingUpdateKayitliLoad:false,
    isLoadingDeleteKayitliYuk: false,
    isLoadingDeleteKayitliAdres: false,
    yukKaydiIsimleri: [],
    adresKaydiIsimleri: [],
    kayitliProjectId: null,

    adresKayitlari: [],
    yukKayitlari: [],

    isError: false,

    selectedKayitliAdres: null,
    selectedKayitliYuk: null,

    kayitliAdresLocationFromMap:null,

    message: "",

    isKayitLoad:false,

    //! sync
    kayitliYukRouteSync: null,
    kayitliYuklerYukDataSync: null,
    kayitliYuklerPaketlemeDataSync: null,
    kayitliYuklerAracDataSync: null,
    kayitliYuklerPaymentDataSync: null

}



export const getYukKaydiIsimleri = createAsyncThunk("kayit/getYukKaydiIsimleri", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Load/GetKayitliWaitingLoadNames`)
        return data
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})

//! bu sadece isimleri
export const getKayitliAdresList = createAsyncThunk("kayit/getKayitliAdresList", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Load/GetKayitliAdresNames`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


//! bu tüm datası (adres yönetimi bölümündeki)
export const getKayitliAdresler = createAsyncThunk("kayit/getKayitliAdresler", async({pagination, selectedIl = "", selectedIlce = ""}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Load/GetKayitliAdresler`, {
            params: { sayi: pagination, Il: selectedIl, Ilce: selectedIlce }
        })
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! bu tüm datası (adres yönetimi bölümündeki)
export const getKayitliYukler = createAsyncThunk("kayit/getKayitliYukler", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/OnKayitlis/GetAll`)
        return data
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})


//! bu adres eklemek için
export const addKayitliAdres = createAsyncThunk("kayit/addKayitliAdres", async(adres, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Load/AddKayitliAdress`, adres)
        if(data.statusCode === 200){
            thunkApi.dispatch(setKayitliAdresLocationFromMap(null))
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Kayıtlı adres başarıyla eklendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


//! bu kayıtlı yükü silmek için
export const deleteKayitliYuk = createAsyncThunk("kayit/deleteKayitliYuk", async(id, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Load/DeletOnKayitliYuk`, id)
        if(isSuccessfulResponse(data)){
            thunkApi.dispatch(getKayitliYukler())
            thunkApi.dispatch(setSelectedKayitliYuk(null))
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Kayıtlı yük başarıyla silindi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            toast.error(data?.message ?? "Kayıtlı yük silinemedi.")
        }
        return data
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})

//! bu kayıtlı adresi silmek için
export const deleteKayitliAdres = createAsyncThunk("kayit/deleteKayitliAdres", async(id, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Load/DeleteKayitliAdresi`, id)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Kayıtlı adres başarıyla silindi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! bu kayıtlı adresi silmek için
export const getKayitliAdresItem = createAsyncThunk("kayit/getKayitliAdresItem", async(givenData, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Load/GetKayitliAdresById`, {
            params: { id: givenData.id }
        })
        const setAddressAction = givenData.isUpdate
            ? setKayitliAdresRouteItemUpdate
            : setKayitliAdresRouteItem
        thunkApi.dispatch(setAddressAction({routeId: givenData.routeId, data: data.data}))
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getKayitliYukItem = createAsyncThunk("kayit/getKayitliYukItem", async(givenData, thunkApi)=> {
    try {
        const {data: response} = await axiosInstance.get(`/OnKayitlis/GetById`, {
            params: {id: givenData}
        })
        const data = getResponseData(response) ?? {}
        const aracTypes = unwrapApiList(thunkApi.getState().adminSett.aracTypes)
        const routePoints = unwrapApiList(data?.routePoints)
        
        //! bunlar add load için
        thunkApi.dispatch(setKayitliYukRouteItem(routePoints))
        thunkApi.dispatch(setKayitliYuklerYukData(data))
        thunkApi.dispatch(setKayitliYuklerPaketlemeData(data))
        thunkApi.dispatch(setKayitliYuklerAracData({aracTypes: aracTypes, data: data}))
        thunkApi.dispatch(setKayitliYuklerPaymentData(data))
        thunkApi.dispatch(setKayitliProjectId(data.companyProjectId))
        
        return {
            kayitliYukRouteSync: routePoints,
            kayitliYuklerYukDataSync: data,
            kayitliYuklerPaketlemeDataSync: data,
            kayitliYuklerAracDataSync: {aracTypes: aracTypes, data: data},
            kayitliYuklerPaymentDataSync: data,
        }
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})

export const getKayitliYukForUpdate = createAsyncThunk("kayit/getKayitliYukForUpdate", async(id, thunkApi)=> {
    try {
        const {data: response} = await axiosInstance.get(`/OnKayitlis/GetById`, {
            params: {id}
        })
        return getResponseData(response)
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})

//! add kayıtlı load

export const addKayitliLoad = createAsyncThunk("kayit/addKayitliLoad", async(givenData, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/OnKayitlis/Add`, givenData)
        
        if(isSuccessfulResponse(data)){
            thunkApi.dispatch(getKayitliYukler())
            thunkApi.dispatch(getYukKaydiIsimleri())
            thunkApi.dispatch(showNestedModal("addLoadKayitResponse"))
            localStorage.removeItem("routeData");
            thunkApi.dispatch(resetAddLoadState())
        } else {
            toast.error(data?.message ?? "Kayıtlı yük eklenemedi.")
        }
        return data
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})

//! kayıtlı yük güncelleme
export const updateKayitliLoad = createAsyncThunk("kayit/updateKayitliLoad", async(givenData, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/OnKayitlis/Update`, {updateOnKayitliDto: givenData})
        
        if(isSuccessfulResponse(data)){
            thunkApi.dispatch(getKayitliYukler())
            thunkApi.dispatch(getYukKaydiIsimleri())
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Kayıtlı yük başarıyla güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        } else {
            toast.error(data?.message ?? "Kayıtlı yük güncellenemedi.")
        }
        
        return data?.data ?? givenData
    } catch (error) {
        showApiError(error)
        return thunkApi.rejectWithValue(getApiErrorMessage(error))
    }
})



//! kayıtlı adres güncelleme

export const updateKayitliAdres = createAsyncThunk("kayit/updateKayitliAdres", async(adres, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Load/UpdateKayitliAdress`, adres)
        if(data.statusCode === 200){
            thunkApi.dispatch(setKayitliAdresLocationFromMap(null))
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Kayıtlı adres başarıyla güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
        return data?.data ?? adres
    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

const kayitSlice = createSlice({
    name: "kayit",
    initialState,
    reducers: {
        //! eklenilen yükün datası kayıtlı yük eklemek için mi yoksa yükler listesine eklemek için mi
        setIsKayitLoad: (state, action) => {
            state.isKayitLoad = action.payload
        },
        //! kayıtlı adresin mapten seçilmesi
        setKayitliAdresLocationFromMap: (state, action) => {
            state.kayitliAdresLocationFromMap = action.payload
        },
        //! kayıtlı adresin seçilmesi
        setSelectedKayitliAdres: (state, action) => {
            state.selectedKayitliAdres = action.payload
        },
        //! kayıtlı yükün seçilmesi
        setSelectedKayitliYuk: (state, action) => {
            state.selectedKayitliYuk = action.payload
        },

        //! ilgili yükün kayıtlı yüklerden mi seçildiğini belirtmek için
        setIsFromKayitliYuk: (state, action) => {
            state.isFromKayitliYuk = action.payload
        },

        setKayitliProjectId: (state, action) => {
            state.kayitliProjectId = action.payload
        },

        deleteKayitlliYukItemRouteItem: (state, action) => {
            
            const updatedList = state.kayitliYukRouteSync?.filter((item) => {
                return item.id !== action.payload.id;
              });
        
            state.kayitliYukRouteSync = updatedList?.map((item, i) => {
                return { ...item, order: i + 1 };
            });
        }   

    },
    extraReducers:(builder)=> {
        builder

        // get Yuk Kaydi Isimleri
        .addCase(getYukKaydiIsimleri.pending, (state)=> {
            state.isLoadingGetYukKaydiIsimleri = true
        })
        .addCase(getYukKaydiIsimleri.fulfilled, (state, action)=> {
            state.isLoadingGetYukKaydiIsimleri = false
            state.yukKaydiIsimleri = unwrapApiList(getResponseData(action.payload))
            
        })
        .addCase(getYukKaydiIsimleri.rejected, (state, action)=> {
            state.isLoadingGetYukKaydiIsimleri = false
            state.isError = true
            state.message = action.payload
        })

        // get Yuk Kaydi Isimleri
        .addCase(getKayitliAdresList.pending, (state)=> {
            state.isLoadingGetAdresKaydiIsimleri = true
        })
        .addCase(getKayitliAdresList.fulfilled, (state, action)=> {
            state.isLoadingGetAdresKaydiIsimleri = false
            const addressNames = action.payload?.data?.$values ?? action.payload?.data
            state.adresKaydiIsimleri = Array.isArray(addressNames) ? addressNames : []
            
        })
        .addCase(getKayitliAdresList.rejected, (state, action)=> {
            state.isLoadingGetAdresKaydiIsimleri = false
            state.isError = true
            state.message = action.payload
        })


        // get kayitli adresler
        .addCase(getKayitliAdresler.pending, (state)=> {
            state.isLoadingGetKayitliAdresler = true
        })
        .addCase(getKayitliAdresler.fulfilled, (state, action)=> {
            state.isLoadingGetKayitliAdresler = false
            const registeredAddresses = action.payload?.data?.$values ?? action.payload?.data
            state.adresKayitlari = Array.isArray(registeredAddresses) ? registeredAddresses : []
            
        })
        .addCase(getKayitliAdresler.rejected, (state, action)=> {
            state.isLoadingGetKayitliAdresler = false
            state.isError = true
            state.message = action.payload
        })

        // get kayitli yukler
        .addCase(getKayitliYukler.pending, (state)=> {
            state.isLoadingGetKayitliYukler = true
        })
        .addCase(getKayitliYukler.fulfilled, (state, action)=> {
            state.isLoadingGetKayitliYukler = false
            state.yukKayitlari = unwrapApiList(getResponseData(action.payload))
        })
        .addCase(getKayitliYukler.rejected, (state, action)=> {
            state.isLoadingGetKayitliYukler = false
            state.isError = true
            state.message = action.payload
        })

        //! bu tüm datası (adres yönetimi bölümündeki)
        .addCase(addKayitliAdres.pending, (state)=> {
            state.isLoadingGetKayitliAdresler = true
        })
        .addCase(addKayitliAdres.fulfilled, (state, action)=> {
            state.isLoadingGetKayitliAdresler = false
            if (action.payload?.data) {
                state.adresKayitlari = [action.payload.data, ...state.adresKayitlari]
            }
        })
        .addCase(addKayitliAdres.rejected, (state, action)=> {
            state.isLoadingGetKayitliAdresler = false
            state.isError = true
            state.message = action.payload
        })

        .addCase(deleteKayitliYuk.pending, (state)=> {
            state.isLoadingDeleteKayitliYuk = true
        })
        .addCase(deleteKayitliYuk.fulfilled, (state, action)=> {
            state.isLoadingDeleteKayitliYuk = false
            const deletedId = action.payload?.data?.id ?? action.meta.arg?.id
            state.yukKayitlari = state.yukKayitlari.filter((item) => item.id !== deletedId )
        })
        .addCase(deleteKayitliYuk.rejected, (state, action)=> {
            state.isLoadingDeleteKayitliYuk = false
            state.isError = true
            state.message = action.payload
        })

        .addCase(deleteKayitliAdres.pending, (state)=> {
            state.isLoadingDeleteKayitliAdres = true
        })
        .addCase(deleteKayitliAdres.fulfilled, (state, action)=> {
            state.isLoadingDeleteKayitliAdres = false
            const deletedId = action.payload?.data?.id ?? action.meta.arg?.id
            state.adresKayitlari = state.adresKayitlari.filter((item) => item.id !== deletedId )
            
        })
        .addCase(deleteKayitliAdres.rejected, (state, action)=> {
            state.isLoadingDeleteKayitliAdres = false
            state.isError = true
            state.message = action.payload
        })

        .addCase(addKayitliLoad.pending, (state)=> {
            state.isLoadingAddKayitliLoad = true
        })
        .addCase(addKayitliLoad.fulfilled, (state, action)=> {
            state.isLoadingAddKayitliLoad = false
            
        })
        .addCase(addKayitliLoad.rejected, (state, action)=> {
            state.isLoadingAddKayitliLoad = false
            state.isError = true
            state.message = action.payload
        })

        .addCase(updateKayitliLoad.pending, (state)=> {
            state.isLoadingUpdateKayitliLoad = true
        })
        .addCase(updateKayitliLoad.fulfilled, (state, action)=> {
            state.isLoadingUpdateKayitliLoad = false
            if (!action.payload?.id) return
            state.yukKayitlari = state.yukKayitlari.map((item) => {
                const shouldItem = item.id === action.payload.id
                if(shouldItem){
                    return {...item, ...action.payload}
                }else{
                    return item
                }
            })
        })
        .addCase(updateKayitliLoad.rejected, (state, action)=> {
            state.isLoadingUpdateKayitliLoad = false
            state.isError = true
            state.message = action.payload
        })

        .addCase(getKayitliYukForUpdate.pending, (state)=> {
            state.isLoadingGetKayitliYukDetails = true
        })
        .addCase(getKayitliYukForUpdate.fulfilled, (state)=> {
            state.isLoadingGetKayitliYukDetails = false
        })
        .addCase(getKayitliYukForUpdate.rejected, (state, action)=> {
            state.isLoadingGetKayitliYukDetails = false
            state.isError = true
            state.message = action.payload
        })
        

        .addCase(updateKayitliAdres.pending, (state)=> {
            state.isLoadingUpdateKayitliLoad = true
        })
        .addCase(updateKayitliAdres.fulfilled, (state, action)=> {
            state.isLoadingUpdateKayitliLoad = false
            state.adresKayitlari = state.adresKayitlari.map((item) => {
                const shouldItem = item.id === action.payload?.id
                if(shouldItem){
                    return {...item, ...action.payload}
                }else{
                    return item
                }
            })  
        })
        .addCase(updateKayitliAdres.rejected, (state, action)=> {
            state.isLoadingUpdateKayitliLoad = false
            state.isError = true
            state.message = action.payload
        })


        .addCase(getKayitliYukItem.pending, (state)=> {
        })
        .addCase(getKayitliYukItem.fulfilled, (state, action)=> {

            const {aracTypes = [], data = {}} = action.payload.kayitliYuklerAracDataSync ?? {}
            const findArac = unwrapApiList(aracTypes).find((item)=> {
              return item?.id === data?.truckTypeId
            })


            state.kayitliYukRouteSync = unwrapApiList(action.payload.kayitliYukRouteSync).map((item) => {
                const sevkBicimIds = unwrapApiList(item?.loadMethods).map(idItem => idItem.methodId)
                const savedLocation = addLoadLocationData?.find(innerItem => innerItem.location === item.location)
                
                return {
                    //! yetkili bilgileri
                    routePointPersonPhoneNumber: item.routePointPersonPhoneNumber,
                    companyName: item.companyName,
                    mailAddress: item.mailAddress,
                    routePointPersonName: item.routePointPersonName,
                    smsVerification: item.smsVerification,
                    smsVerificationPhoneNumber: item.smsVerificationPhoneNumber,


                  adres: item.address,
                //   date: moment(item.loadDate).format('YYYY-MM-DD'),
                //   dateEngec: moment(item.lateLoadDate).format('YYYY-MM-DD'),
                //   saatBitis: item.lateLoadTime,
                //   saatBaslangic: item.loadTime,
                  date: "",
                  dateEngec: "",
                  saatBitis: "",
                  saatBaslangic: "",
                  locationData: {
                    il: savedLocation?.city ?? item?.city ?? "",
                    ilce: savedLocation?.town ?? item?.town ?? "",
                    lat: item?.lat ?? savedLocation?.lat ?? "",
                    lng: item?.lng ?? savedLocation?.lng ?? "",
                    location: item?.location ?? savedLocation?.location ?? "",
                    bolge: savedLocation?.region ?? "",
                    ilId: savedLocation?.cityId ?? "",
                    ilceId: savedLocation?.townId ?? "",
                    googleLat: item?.googleLat ?? item?.lat ?? "",
                    googleLng: item?.googleLng ?? item?.lng ?? "",
                    googleLocation: item?.googleAddress ?? "",
                    googleSearchText: item?.googleAddress ?? "",
                    isGoogleAddressSelected: Boolean(item?.isGoogleAddressSelected),
                    isfirstChanged: false,
                  },
                  id: item.id,
                  adresTarif: item?.forDirections ?? "",
                  adresKaydedilsinMi: item?.isAddressSaved,
                  order: item?.order,
                  adresBaslik: item?.savedAddressName ?? "",
                  saatAllTime: false,
                  locationType: item?.loadOrUnload === 0 ? "yukleme" : "bosaltma",
                  //! kendinden önceki tarihle farkı kontrol ediyor (ffk)
                  dateInfo: false,
                  //! kendinden sonra tarihle farkı kontrol ediyor (ffk)
                  dateAfterInfo: false,
                  //! bugünün tarihinden önce bir tarih girildi mi (ffk)
                  currentDateControl:false,
        
                  sevkBicimleri: sevkBicimleriOptions.map(innerItem => {
                    return {
                      ...innerItem,
                      status: sevkBicimIds.includes(innerItem.id)
                    }
                  })
                }
              })
            //! seçili kayıtlı yükün yük bilgilerinin set edilmesi
            state.kayitliYuklerYukDataSync = {
                yuklemeTuru: yuklemeTuruOptions.find(item => item?.value === action.payload.kayitliYuklerYukDataSync.isParsiyel),
                yukTuru: action.payload.kayitliYuklerYukDataSync.loadType,
                yukADR: action.payload.kayitliYuklerYukDataSync.isDangerous,
                yukAdrDescription: action.payload.kayitliYuklerYukDataSync.dangerousDescription,
                agirlikBirim: agirlikBirimOptions.find(item => item.text === action.payload.kayitliYuklerYukDataSync.loadUnit) ,
                toplamAgirlik: action.payload.kayitliYuklerYukDataSync.loadQuantity,
                toplamHacim: action.payload.kayitliYuklerYukDataSync.loadBulk,
                yukDesc: action.payload.kayitliYuklerYukDataSync.loadDescription,
                yukunDegeri: action.payload.kayitliYuklerYukDataSync.loadValue,
                yukunDegeriKontrol: false,
                ustUsteYuklenmesin: Boolean(action.payload.kayitliYuklerYukDataSync.isStacked),
              }
            //! seçili kayıtlı yükün paketleme bilgilerinin set edilmesi
            state.kayitliYuklerPaketlemeDataSync = unwrapApiList(action.payload.kayitliYuklerPaketlemeDataSync?.packingingTypes).map((item) => {
                const findPaketlemeType = paketlemeItemDimensions?.find(findItem => findItem.id === item.packagingUnitId)
                return {
                  id: nanoid(),
                  activePaketlemeTypeId: findPaketlemeType?.id,
                  paketlemeType: findPaketlemeType?.name,
                  list: unwrapApiList(item?.olculers)
                }
              })
            //! seçili kayıtlı yükün araç bilgilerinin set edilmesi
            state.kayitliYuklerAracDataSync = {
                aracSayisi: data.truckQuantity,
                aracTypeName: findArac?.name,
                aracTypeId: data?.truckTypeId,
                kasaTypeName: data?.trailerType,
                kasaTypeId: data?.trailerTypeId,
                aracSayisiKontrol:false,
                digerOzellikler: data?.truckDescription,
                kasaTypeOptions: unwrapApiList(findArac?.trailerTypesModel),
                zeminType: zeminTypeOptions?.find(item => item.value === data?.groundTypeId) ?? {value: 0, text: "Farketmez"}
            }
            //! seçili kayıtlı yükün ödeme bilgilerinin set edilmesi
            state.kayitliYuklerPaymentDataSync = {
                hedefNakliyefiyat: action.payload.kayitliYuklerPaymentDataSync.freight,
                fiyatlandirmaType: fiyatlandirmaTipOptions?.find(item => item.value === action.payload.kayitliYuklerPaymentDataSync.paymentUnit),
                fiyatYayinlansin: action.payload.kayitliYuklerPaymentDataSync.freightVisibility,
                odemeSekli: odemeSekliOptions?.find(item => item.text === action.payload.kayitliYuklerPaymentDataSync.paymentType) ,
                odemeSekliDigerAciklama: action.payload.kayitliYuklerPaymentDataSync.otherPaymentDescription,
                yakitDurumu: yakitDurumuOptions?.find(item => item.value === action.payload.kayitliYuklerPaymentDataSync.fuelPaymentId),
                yakitOrani: action.payload.kayitliYuklerPaymentDataSync.fuelPayment,
                komisyonDurumu: komisyonDurumuOptions.find(item => item.value === action.payload.kayitliYuklerPaymentDataSync.commissionPaymentId),
                komisyonMiktari: action.payload.kayitliYuklerPaymentDataSync.commissionPayment,
              }
            
        })
        .addCase(getKayitliYukItem.rejected, (state, action)=> {
            state.isError = true
            state.message = action.payload
        })

    }
})


export const {
    setIsKayitLoad,
    setKayitliAdresLocationFromMap,
    setSelectedKayitliAdres,
    setSelectedKayitliYuk,
    setIsFromKayitliYuk,
    setKayitliProjectId,
    deleteKayitlliYukItemRouteItem
} = kayitSlice.actions
export default kayitSlice.reducer
